<template>
    <footer>
        <b-container fluid class="footer-container">
            <b-row>
                <b-col xl="3" lg="3" md="4" sm="6" cols="10">
                    <img src="../assets/pp_logo_3_white.png" id="logo" width=70% height=auto class="pp-logo" alt="Product Planet logo"/>
                </b-col>
                <b-col xl="1" lg="1" md="0" sm="0" cols="0"></b-col>
                <b-col xl="3" lg="3" md="5" sm="8" cols="12" class="text-left">
                    <h6 class="footer-col">About Us</h6>
					<div class="text-left footer-content">
						Product Planet helps developers, designers, data scientists, and product managers learn the latest skills, and get ahead in their career.<br><br>		
					</div>
                </b-col>
                <b-col xl="1" lg="1" md="0" sm="0" cols="0"></b-col>
                <b-col xl="2" lg="2" md="3" sm="8" cols="12" class="text-left">
                    <h6 class="footer-col">Products</h6>
					<div class="text-left footer-content">
						<ul class="list-unstyled">
							<!--<li><a href="/practice">Practice</a></li> -->
                            <li><a href="/home">Browse Courses</a></li>
                           <!-- <li><a href="/practice">Practice</a></li> -->
                            <li><a href="/custom-path">Custom Path</a></li>
                            <li><a href="/assess">Assess Skills</a></li>
                          <!--  <li><a href="/assess">Skill Assessments</a></li> -->
							<!--<li><a href="/companies">For Companies</a></li> -->
                            <li><a href="https://blog.productplanet.io">Blog</a></li>
						</ul>
					</div>
                </b-col>
                <b-col xl="2" lg="2" md="3" sm="8" cols="12" class="text-left">
                    <h6 class="footer-col">Contact Us</h6>
                    <div class="text-left footer-content">
                        <div>admin@productplanet.io</div>
                        <div>+91-9599022950</div>
                        <div>© Product Planet</div>
                        <a href="privacy-policy.html">Privacy Policy</a>
                    </div>
                </b-col>

            </b-row>
        </b-container>
    </footer>
    
</template>


<script>
export default {
    name: 'FooterDark'
}
</script>
    

<style scoped>
    .footer-container.container-fluid {
        background-color:#333;
        color:#ccc;
    }

    a {
        text-decoration: none;
        color:#ccc !important;
    }

    .text-left .footer-content {
        font-size: 13px;
    }

    #logo {
        margin-bottom:10%;
        margin-top:10%;
    }


    @media(min-width:768px) {
        .footer-col {
            margin-top:0px;
        }
    }

    @media(max-width: 768px) {
        .footer-col {
            margin-top:40px;
        }
    }
    

</style>
